import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Seo from "../components/Seo";
import HowHero from "../sections/HowHero";
import StageSequence from "../sections/StageSequence";
import HowClosing from "../sections/HowClosing";

const HowItWorksPage = () => (
    <div className="min-h-screen bg-ink text-white">
        <Seo
            title="How BuildEase Works — From Plans to Informed Decisions"
            description="Five steps: create your project, upload your architectural plans, analyse the available information, explore construction insights and make more informed decisions."
        />
        <Navbar />
        <main>
            <HowHero />
            <StageSequence />
            <HowClosing />
        </main>
        <Footer />
    </div>
);

export default HowItWorksPage;
